// extracted by css-extract-rspack-plugin
export default {"contents":"Top__contents--GMaJy","panel":"Top__panel--AQAlz","title":"Top__title--mh64K","icon":"Top__icon--VCGV8","buttons":"Top__buttons--CO5Gg"};